import styled from 'styled-components';
import { Drawer } from '@idaho-aeyc/ui-kit';

export const SDrawer = styled(Drawer)``;
